/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

// todo 写页面样式的时候,调完pc端样式,移动端还要调式,移动端样式和pc端可能完全不同.
import Vue from 'vue'
import App from './App.vue'


// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
// Vue.use(Vuesax);


// import 'element-ui/lib/theme-chalk/index.css';
import './assets/scss/eleThemeChange.scss'; // 修改element-ui的主题色


// 修改element-ui的样式的
import './assets/scss/element.scss'

import './assets/css/quill_base.css'
//指令
import '@/directive/emoji.js';
// import ElementUI from 'element-ui';
// Vue.use(ElementUI);
//element 按需引入,需要用组件先引入

import {
  Alert,
  Avatar,
  Tooltip,
  Form,
  FormItem,
  Image,
  Tree,
  Input,
  InputNumber,
  Select,
  Option,
  Row,
  Col,
  Collapse,
  CollapseItem,
  Rate,
  Carousel,
  CarouselItem,
  Upload,
  Tag,
  Table,
  TableColumn,
  DatePicker,
  Dialog,
  TimeSelect,
  TimePicker,
  Tabs,
  TabPane,
  Popover,
  Progress,
  Checkbox,
  CheckboxGroup,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Divider,
  Drawer,
  Radio,
  RadioGroup,
  Button,
  Loading,
  Message,
  MessageBox,
  Menu,
  Submenu,
  MenuItem,
  Switch,
  Scrollbar,
  Link,
} from 'element-ui';



Vue.use(Alert,);
Vue.use(Avatar,);
Vue.use(Tooltip,);
Vue.use(Form,);
Vue.use(FormItem,);
Vue.use(Image,);
Vue.use(Tree,);
Vue.use(Input,);
Vue.use(InputNumber,);
Vue.use(Select,);
Vue.use(Option,);
Vue.use(Row,);
Vue.use(Col,);
Vue.use(Collapse,);
Vue.use(CollapseItem,);
Vue.use(Rate,);
Vue.use(Carousel,);
Vue.use(CarouselItem,);
Vue.use(Upload,);
Vue.use(Tag,);
Vue.use(Table,);
Vue.use(TableColumn,);
Vue.use(DatePicker,);
Vue.use(Divider,);
Vue.use(TimeSelect,);
Vue.use(TimePicker,);
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Popover,);
Vue.use(Progress,);
Vue.use(Checkbox,);
Vue.use(CheckboxGroup,);
Vue.use(Dropdown,);
Vue.use(DropdownMenu,);
Vue.use(DropdownItem,);
Vue.use(Drawer,);
Vue.use(Radio,);
Vue.use(RadioGroup,);
Vue.use(Button,);
Vue.use(Link,);
/*Vue.use(Message); Message和MessageBox不用use
Vue.use(MessageBox);*/
Vue.use(Switch,);
Vue.use(Menu,);
Vue.use(Submenu,);
Vue.use(MenuItem,);
Vue.use(Scrollbar);
Vue.use(Dialog,);
Vue.use(Loading.directive,);

Vue.prototype.$loading = Loading.service;
// $loading,$msgbox,$message 不是user而是加入到prototype原型中
Vue.prototype.$msgbox = MessageBox;
Vue.prototype.$confirm = MessageBox.confirm;
Vue.prototype.$message = Message;

import moment from 'moment'
moment.locale('zh-cn');
Vue.prototype.$moment = moment; //时间处理

import { Calendar } from 'vant';
// 2. 引入组件样式
import 'vant/lib/index.css';
Vue.use(Calendar);

import selectDateDuration from './components/common/mobile/selectDateDuration';
Vue.component('select-date-duration',selectDateDuration);

// axios
import request from '@/utils/ajax';
Vue.prototype.$http = request;

import config from '@/utils/globalConfig';
Vue.prototype.$config = config;

import { uploadFile } from "@/utils/uploadFile";
import { getBase64,base64toFile } from "@/utils/common";
import { isAuth } from '@/utils/index'
Vue.prototype.$uploadFile = uploadFile;
Vue.prototype.$getBase64 = getBase64;
Vue.prototype.$base64toFile = base64toFile;
Vue.prototype.isAuth = isAuth;

import md5 from "js-md5";
Vue.prototype.$md5 = md5;

import oss from "@/utils/oss.js";
Vue.prototype.$oss = oss;

// Vuesax安装
// Theme Configurations
import '../themeConfig.js'


import _ from 'lodash';//global lodash
// Globally Registered Components
import './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router/router'

// Vuex Store
import store from './store/index'



// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

import './assets/libraryCss/quill_base.css' // quill富文本编辑器

// Feather font icon
// require('./assets/css/iconfont.css') // 不引用,因自己有阿里的iconfont
// 下载引入自己的iconfont todo

import '@/assets/iconfont/iconfont.css';       //


// 一些在各种媒体查询下的显示隐藏类
import '@/assets/scss/media.scss';
//修改vuesax 组件的样式
import '@/assets/scss/vuesaxChange.scss';
//公共样式
import '@/assets/scss/public.scss';

// 地区插件 todo 需要显示国家的
import 'vue-area-linkage/dist/index.css'; // v2 or higher
import VueAreaLinkage from 'vue-area-linkage';

Vue.use(VueAreaLinkage);

Vue.config.productionTip = false;

const vm = new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');

export default vm
